module.exports = {
      id: "icon-audio-fb-usage",
      viewBox: "0 0 25.21 25.21",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-audio-fb",
      toString: function () {
        return this.url;
      }
    }